import { DatePicker, Popover, Input, Button, Modal, Space } from "antd";
import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import Delivered from "../../../../assets/customSVG/inbox/Delivered";
import { ICONS } from "../../../../assets/icons";
import Header from "../../../../components/commonComponents/modals/Header";
import AttachmentsManager from "../sidebar/AttachmentsManager";
import NotesSection from "./NotesSection";
import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";
import { validateEmail } from "../../../../helper/validation";
import { useNavigate } from "react-router-dom";
import { hexToRgba } from "../../../../helper/colors";
import { useSelector } from "react-redux";
import EditIcon from "../../../../assets/customSVG/EditIcon";
import Tag from "../../../../assets/customSVG/Tag";
import AddCircle from "../../../../assets/customSVG/AddCircle";
import useAddTags from "../../../../hooks/useAddTags";
import useTags from "../../../../hooks/useTags";
import {
  AttributeList,
  cityListApi,
  countryListApi,
  stateListApi,
  ProfileAttributeValueCreate,
  ProfileAttributeValueUpdate,
  crmTagSingleAssign,
  crmTagRemove,
} from "../../../crm/api/Api";
import {
  INITIAL_STATE,
  singleContactReducer,
} from "../../../crm/reducers/singleContactReducer";
import { formatPhoneNumber } from "../../helper";
import "../../styles/popover.css";
import Select from "../../../../components/commonComponents/select";
import { showErrorToast, showSuccessToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";
import NotificationContext from "../../../../providers/NotificationProvider";
import Tick from "../../../../assets/customSVG/Tick";
import Close from "../../../../assets/customSVG/Close";
import { DownOutlined } from '@ant-design/icons';
import { Address } from "../../../crm/components/commonComponents/location/Address";
import { Province } from "../../../crm/components/commonComponents/location/Province";
import { City } from "../../../crm/components/commonComponents/location/City";
import Tags from "../../../crm/components/main/contact/Tags";
import { useDispatch } from "react-redux";
import Label from "../../../crm/components/commonComponents/label";
import { gender } from "../../../../constant/app/crm/crm";
import { formatInternationalPhone } from "../../helper";
import { whatsappBusinessNumbers } from "../../api/Api";

const SideNavComponent = ({
  selectedPerson,
  setIsSideNavOpen,
  contactPopover,
  setContactPopover,
  data,
  type,
  journeyLists,
  attachments,
  notes,
  noteDelete,
  attachmentFilter,
  setAttachmentFilter,
  getAttachments,
  getNotes,
  setIsSideNavOpenIcon3,
  setIsSideNavOpenIcon2,
  setIsSideNavOpenIcon1,
  setIsSideNavOpenIcon4,
  profession,
  setChatToggle,
  chatToggle,
}) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [businessNumberDetails, setBusinessNumberDetails] = useState(null);
  const [loadingBusinessNumber, setLoadingBusinessNumber] = useState(false);
  const [editedScope, setEditedScope] = useState(null);
  const [editedAttributes, setEditedAttributes] = useState({});
  const [editingField, setEditingField] = useState(null);
  const [tempValues, setTempValues] = useState({});

  // State for country, state, and city dropdowns
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({ name: '', id: null });
  const [selectedState, setSelectedState] = useState({ name: '', id: null });
  const [selectedCity, setSelectedCity] = useState({ name: '', id: null });
  const [popoverVisible, setPopoverVisible] = useState({
    country: false,
    state: false,
    city: false,
  });

  // State for tag management
  const [isTagPopoverOpen, setIsTagPopoverOpen] = useState(false);

  const closeAction = (tagId) => {
    handleRemoveTag(tagId);
  };

  const handleSaveAttribute = async (attr, scope, newValue) => {
    if (!selectedPerson?.contact_person_id) {
      showErrorToast(notification, "Contact person ID is missing");
      return;
    }

    // For country/state/city, use the selected values
    let valueToSave = newValue;
    if (attr.name === 'country') {
      valueToSave = selectedCountry.name;
    } else if (attr.name === 'province' || attr.name === 'state') {
      valueToSave = selectedState.name;
    } else if (attr.name === 'city') {
      valueToSave = selectedCity.name;
    }

    setIsSaving(true);
    try {
      const basePayload = {
        contact_person_id: selectedPerson.contact_person_id,
        profile_attribute_id: attr.id,
        value: valueToSave
      };

      let response;

      // Find the existing attribute value from contact_person_values
      const existingValue = attributes.contact_person_values.find(
        v => v.contact_person_profile_attribute_id === attr.id
      );

      // If we have an existing value, update it, otherwise create a new one
      if (existingValue) {
        // Update existing value using the ID from contact_person_values
        response = await ProfileAttributeValueUpdate(currentBrand?.brand_id, {
          ...basePayload,
          id: existingValue.id
        });
      } else {
        // Create new value with the exact required fields
        response = await ProfileAttributeValueCreate({
          brand_id: currentBrand?.brand_id,
          contact_person_id: selectedPerson.contact_person_id,
          profile_attribute_id: attr.id,
          value: valueToSave
        });
      }

      if (response?.status === 200) {
        showSuccessToast(notification, response?.data?.message || `Successfully saved ${attr.label || attr.name}`);
        // Refresh attributes to get the latest data
        fetchAttributes();
      } else {
        showErrorToast(notification, response?.response?.data?.error || `Failed to save ${attr.label || attr.name}`);
      }
    } catch (error) {
      console.error(`Error saving ${attr.label || attr.name}:`, error);
      showErrorToast(notification, error.response?.data?.error || error.message || `Failed to save ${attr.label || attr.name}`);
    } finally {
      setIsSaving(false);
      setEditingField(null);
      setTempValues(prev => {
        const newValues = {...prev};
        delete newValues[attr.id];
        return newValues;
      });
    }
  };


  const [attributes, setAttributes] = useState({
    scopes: [],
    contact_person_values: [],
    contact_person_tags_list: []
  });

  // Name
  const nameAttribute = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'first_name')
  )?.profile_attributes?.find(attr => attr.name === 'first_name');

  // const nameAttribute2 = attributes?.scopes?.find(scope =>
  //   scope.profile_attributes?.find(attr => attr.name === 'middle_name')
  // )?.profile_attributes?.find(attr => attr.name === 'middle_name');

  const nameAttribute3 = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'last_name')
  )?.profile_attributes?.find(attr => attr.name === 'last_name');

  const nameId = nameAttribute?.id;
  // const nameId2 = nameAttribute2?.id;
  const nameId3 = nameAttribute3?.id;
    const firstname = nameId && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId)?.value;
  // const middlename = nameId2 && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId2)?.value;
  const lastname = nameId3 && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === nameId3)?.value;
  const fullname = firstname + (lastname ? ` ${lastname}` : '');
  // Email
  const emailAttribute = attributes?.scopes?.find(scope =>
    scope.profile_attributes?.find(attr => attr.name === 'email_address')
  )?.profile_attributes?.find(attr => attr.name === 'email_address');

  const emailId = emailAttribute?.id;
  const email = emailId && attributes?.contact_person_values?.find(attr => attr.contact_person_profile_attribute_id === emailId)?.value;

  // Fetch Brand
  const { currentBrand } = useSelector((state) => state?.app);

  // Notification Context
  const notification = useContext(NotificationContext);

  // Restricted Attributes
  const restrictedAttributes = ['mobile_number', 'country_code', 'email_address', 'age', 'whatsapp_opt_out'];

  // Get input type based on attribute type
  const getInputType = (attributeType, attributeName) => {
    if (attributeName === 'gender') return 'gender';

    switch (attributeType) {
      case 'number':
        return 'number';
      case 'date':
        return 'date';
      case 'boolean':
        return 'checkbox';
      case 'string':
      default:
        return 'text';
    }
  };


    // Fetch business number details when selectedPerson changes
    useEffect(() => {
      const fetchBusinessNumber = async () => {
        if (!selectedPerson?.from_number) return;
        
        try {
          setLoadingBusinessNumber(true);
          const response = await whatsappBusinessNumbers(
            currentBrand?.brand_id,
            {
              search: selectedPerson.from_number,
              call_meta: 'false'
            }
          );
          
          if (response?.data?.wapp_business_num?.[0]) {
            setBusinessNumberDetails(response.data.wapp_business_num[0]);
          }
        } catch (error) {
          showErrorToast(notification, error.response?.data?.error || error.message);
        } finally {
          setLoadingBusinessNumber(false);
        }
      };
      
      fetchBusinessNumber();
    }, [selectedPerson?.from_number, currentBrand?.brand_id]);
    
    // Clear business number details when component unmounts
    useEffect(() => {
      return () => {
        setBusinessNumberDetails(null);
      };
    }, []);
  
    
  const fetchAttributes = React.useCallback(async () => {
    let isMounted = true;
    
    try {
      const response = await AttributeList(currentBrand?.brand_id, selectedPerson?.contact_person_id);

      if (response?.data && isMounted) {
        const { scopes_and_attributes_list, contact_person_values = [], contact_person_tags_list = []  } = response.data;
        
        // Create a map of attribute IDs to their values for quick lookup
          const attributeValuesMap = contact_person_values.reduce((acc, cv) => {
            acc[cv.contact_person_profile_attribute_id] = cv.value;
            return acc;
          }, {});
          
          // Initialize mergedScopes with an empty array if scopes_and_attributes_list is null/undefined
          let mergedScopes = [];
          
          if (Array.isArray(scopes_and_attributes_list)) {
            // Map through scopes and their attributes, adding the corresponding values
            mergedScopes = scopes_and_attributes_list.map(scope => ({
              ...scope,
              profile_attributes: Array.isArray(scope.profile_attributes) 
                ? scope.profile_attributes.map(attr => ({
                    ...attr,
                    value: attributeValuesMap[attr.id] || ''
                  }))
                : []
            }));
          }

          if (isMounted) {
            setAttributes({
              scopes: mergedScopes,
              contact_person_values: contact_person_values,
              contact_person_tags_list: contact_person_tags_list
            });
          }
          
        }
      } catch (error) {
        showErrorToast(notification, error.response?.data?.error || error.message || 'Failed to fetch profile attributes');
      } 
      
      // No need to return a cleanup function here
    }, [selectedPerson?.contact_person_id, currentBrand?.brand_id, notification]);

  // CRM STATES


  useEffect(() => {
    if (selectedPerson?.contact_person_id) {
      fetchAttributes();
    }
  }, [selectedPerson?.contact_person_id]);

  // Handle tag assignment
  const handleAssignTag = async (tagId) => {
    try {
      const response = await crmTagSingleAssign(
        selectedPerson?.contact_person_id,
        tagId,
        currentBrand?.brand_id
      );

      if (response?.status === 200) {
        showSuccessToast(notification, 'Tag assigned successfully');
        fetchAttributes(); // Refresh the contact data
      }
    } catch (error) {
      console.error('Error assigning tag:', error);
      showErrorToast(notification, 'Failed to assign tag');
    }
  };

  // Handle tag removal
  const handleRemoveTag = async (tagId) => {
    try {
      const response = await crmTagRemove(
        selectedPerson?.contact_person_id,
        tagId,
        currentBrand?.brand_id
      );

      if (response?.status === 200) {
        showSuccessToast(notification, 'Tag removed successfully');
        fetchAttributes(); // Refresh the contact data
      }
    } catch (error) {
      console.error('Error removing tag:', error);
      showErrorToast(notification, 'Failed to remove tag');
    }
  };

  const firstLetter =
    data?.information?.first_name !== "UNKNOWN"
      ? data?.information?.first_name?.slice(0, 1).toUpperCase()
      : selectedPerson?.profile_name?.slice(0, 1).toUpperCase();

  const colors = firstLetter ? getRandomColorsBassedOnLetters(firstLetter) : "";

  // attachment filter
  const handleFilterChange = (filter) => {
    setAttachmentFilter(filter);
    getAttachments(filter);
  };

  // --- single file download ---
  const handleDownloadItem = async (item) => {
    try {
      // 1) fetch the file
      const res = await fetch(item.file_url);
      if (!res.ok) throw new Error("Network response was not ok");

      // 2) turn it into a blob
      const blob = await res.blob();

      // 3) make an object URL
      const url = window.URL.createObjectURL(blob);

      // 4) create a temporary link with download attr
      const link = document.createElement("a");
      link.href = url;
      link.download = item.file_name; // suggests the filename
      document.body.appendChild(link);
      link.click();

      // 5) clean up
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      // optionally show a user error toast
    }
  };

  // --- bulk download as ZIP ---
  const handleDownloadItems = async (selectedItems) => {
    try {
      // Option A: parallel downloads
      await Promise.all(
        selectedItems.map(async (item) => {
          const res = await fetch(item.file_url);
          if (!res.ok) throw new Error(`Failed to fetch ${item.file_name}`);
          const blob = await res.blob();

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = item.file_name;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
      );

      // Option B: sequential downloads (uncomment if you run into throttling)
      // for (const item of selectedItems) {
      //   const res = await fetch(item.file_url);
      //   const blob = await res.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = item.file_name;
      //   document.body.appendChild(link);
      //   link.click();
      //   link.remove();
      //   window.URL.revokeObjectURL(url);
      // }
    } catch (err) {
      console.error("Bulk download failed:", err);
      // show an error toast if you like
    }
  };

  // navigate to contact details page
  const navigate = useNavigate();

  // Fetch tags on component mount
  useEffect(() => {
    if (data?.tags && data.tags.length > 0) {
      // setSelectedTagIds(data.tags.map(tag => tag.id));
    }
  }, [data?.tags]);

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await countryListApi();
        if (response?.data?.data) {
          setCountryList(response.data.data);
        } else {
          console.error('Unexpected API response format:', response);
          setCountryList([]);
        }
      } catch (error) {
        console.error('Error fetching countries:', error);
        setCountryList([]);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states when country is selected
  const fetchStates = async (countryId) => {
    try {
      const response = await stateListApi(countryId);
      if (response?.data?.data) {
        setStateList(response.data.data);
      } else {
        console.error('Unexpected API response format for states:', response);
        setStateList([]);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      setStateList([]);
    }
  };

  // Fetch cities when state is selected
  const fetchCities = async (stateId) => {
    try {
      const response = await cityListApi(stateId);
      if (response?.data?.data) {
        setCityList(response.data.data);
      } else {
        console.error('Unexpected API response format for cities:', response);
        setCityList([]);
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
      setCityList([]);
    }
  };

  // Handle country selection
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setSelectedState({ name: '', id: null });
    setSelectedCity({ name: '', id: null });
    setStateList([]);
    setCityList([]);
    if (country.id) {
      fetchStates(country.id);
    }
    setPopoverVisible({ ...popoverVisible, country: false });
  };

  // Handle state selection
  const handleStateSelect = (state) => {
    setSelectedState(state);
    setSelectedCity({ name: '', id: null });
    setCityList([]);
    if (state.id) {
      fetchCities(state.id);
    }
    setPopoverVisible({ ...popoverVisible, state: false });
  };

  // Handle city selection
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setPopoverVisible({ ...popoverVisible, city: false });
  };

  return (
    <div>
      {type === "contact" && (
        <div className="w-[20vw]">
          <div className="w-100 flex-row align-center space-between bg-white">
            <Header
              title={"Contact Details"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
              goToContact={() => {
                navigate(`/user/crm/${selectedPerson?.contact_person_id}`, { state: { colors }});
              }}
            />
          </div>
          <div className="h-[90vh] overflow-y-scroll bg-[#F9F9FC]">
            {/* Overview */}
            <div
              className="w-[92] b-radius p-[15px] m-10 gap-2 flex-column  bg-white"
              style={{
                boxShadow: "0px 4px 4px 0px #0000000A",
              }}
            >
              
              <Popover
                trigger="click"
                open={contactPopover}
                onOpenChange={(open) => {
                  if (!open) {
                    setContactPopover(false);
                  }
                }}
                overlayClassName="contact-details-popover"
                placement="left"
                closable={false}
                arrow={false}
                content={
                  <>
                    <Header
                      title="Contact Details"
                      handleCancel={() => setContactPopover(false)}
                      className="new-header"
                    />
                  </>
                }
              >
                <div className=" w-100 flex-row space-between">
                  <div className="flex-row align-center gap-2">
                    <span className="capitalize font-[500] text-[1vw]">
                      Overview
                    </span>
                  </div>
                </div>
              </Popover>
              <span className="border-b-[1px]" />
              <div className="w-100">
                <div className="w-100 flex-row align-center space-between mt-20 mb-10">
                  <span className="sidebar-sub-header">Full Name</span>
                  <span className="new-body-text">
                  {(() => {
                    const displayName = fullname || selectedPerson?.profile_name || "";
                    return displayName
                      .split(" ")
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                      .join(" ");
                  })()}
                  </span>
                </div>
                <div className="w-100 flex-row align-center space-between mt-20 mb-10">
                  <span className="sidebar-sub-header">Phone</span>
                  <span className="new-body-text">
                    +{selectedPerson?.phone_country_code}{" "}
                    {selectedPerson?.to_number}
                  </span>
                </div>
                <div className="w-100 flex-row align-center space-between mt-20 mb-10">
                  <span className="sidebar-sub-header">Email Address</span>
                  <span className="new-body-text">
                    {email || "-"}
                  </span>
                </div>
                {/* from number */}
                {selectedPerson?.from_number && ( 
                  <div className="w-100 flex-column mt-20 mb-10">
                    <div className="w-100 flex-row align-center space-between">
                      <span className="sidebar-sub-header">From Number</span>
                      <span className="new-body-text">
                        + {formatInternationalPhone(selectedPerson?.from_number)}
                      </span>
                    </div>
                    {loadingBusinessNumber ? (
                      <></>
                      // <div className="w-100 flex-row justify-end mt-10">
                      // </div>
                    ) : businessNumberDetails ? (
                      <div className="w-100 flex-column gap-5 mt-20">
                        <div className="w-100 flex-row space-between">
                          <span className="sidebar-sub-header">Display Name</span>
                          <span className="new-body-text">
                            {businessNumberDetails.send_from_phone_name || '-'}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
                
                {/* contact origin */}
                {data?.information?.contact_origin && (
                  <div className="w-100 flex-row align-center space-between mt-20 mb-10">
                    <span className="sidebar-sub-header">Contact Origin</span>
                    <span className="new-body-text">
                      {data?.information?.contact_origin}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* Attributes */}
            {attributes.scopes.length > 0 ? (
              attributes.scopes.map((scope) => (
                <div
                  key={scope.id}
                  className="w-[95%] b-radius p-[15px] m-10 gap-0 flex-column bg-white"
                  style={{
                    boxShadow: "0px 4px 4px 0px #0000000A",
                  }}
                >
                  <div className="w-100 flex-row space-between align-center">
                    <span className="font13px-500">{scope.label || scope.name}</span>
                    <Popover
                      trigger="click"
                      open={infoOpen && editedScope?.id === scope.id}
                      onOpenChange={(visible) => {
                        if (visible) {
                          setEditedScope(scope);
                          // Initialize editedAttributes with current values
                          const initialValues = {};
                          scope.profile_attributes
                            .filter(attr => !restrictedAttributes.includes(attr.name))
                            .forEach(attr => {
                              initialValues[attr.id] = attr.value || '';
                            });
                          setEditedAttributes(initialValues);
                          setTempValues({});
                          setEditingField(null);
                        } else {
                          setEditedScope(null);
                          setEditedAttributes({});
                        }
                        setInfoOpen(visible);
                      }}
                      // overlayClassName="contact-details-popover"
                      placement="right"
                      content={
                        <div style={{ width: 400, padding: '16px' }}>
                          <div className="flex-column" style={{ gap: '16px' }}>
                            {scope.profile_attributes
                              .filter(attr => !restrictedAttributes.includes(attr.name))
                              .map(attr => (
                                <div key={attr.id}>
                                  <div className="flex-row space-between align-center mb-1">
                                    <div className="font13px-600">
                                      {attr.label || attr.name}
                                    </div>
                                    
                                  </div>
                                  <div className="flex-row space-between align-center">
                                    {['country', 'province', 'state', 'city'].includes(attr.name) ? (
                                    <div className="w-full">
                                      <Popover
                                        trigger="click"
                                        placement="bottomLeft"
                                        open={editingField === attr.id && (popoverVisible.country || popoverVisible.state || popoverVisible.city)}
                                        onOpenChange={(open) => {
                                          if (open) {
                                            setEditingField(attr.id);
                                            if (attr.name === 'country') {
                                              setPopoverVisible({ country: true, state: false, city: false });
                                            } else if (['province', 'state'].includes(attr.name)) {
                                              if (!selectedCountry.id) {
                                                showErrorToast(notification, 'Please select a country first');
                                                return;
                                              }
                                              setPopoverVisible({ country: false, state: true, city: false });
                                            } else if (attr.name === 'city') {
                                              if (!selectedState.id) {
                                                showErrorToast(notification, 'Please select a state/province first');
                                                return;
                                              }
                                              setPopoverVisible({ country: false, state: false, city: true });
                                            }
                                          } else {
                                            setPopoverVisible({ country: false, state: false, city: false });
                                          }
                                        }}
                                        content={
                                          <div className="w-64">
                                            {attr.name === 'country' ? (
                                              <Address
                                                countryListss={countryList}
                                                selectedLocation={{
                                                  country: selectedCountry,
                                                  state: selectedState,
                                                  city: selectedCity
                                                }}
                                                handleLocationClick={(type, name, id) => {
                                                  if (type === 'country') {
                                                    handleCountrySelect({ id, name });
                                                  }
                                                }}
                                                locationType="primary"
                                              />
                                            ) : ['province'].includes(attr.name) ? (
                                              <Province
                                                stateList={stateList}
                                                selectedLocation={{
                                                  country: selectedCountry,
                                                  state: selectedState,
                                                  city: selectedCity
                                                }}
                                                handleLocationClick={(type, name, id) => {
                                                  if (type === 'state') {
                                                    handleStateSelect({ id, name });
                                                  }
                                                }}
                                                locationType="primary"
                                              />
                                            ) : (
                                              <City
                                                cityList={cityList}
                                                selectedLocation={{
                                                  country: selectedCountry,
                                                  state: selectedState,
                                                  city: selectedCity
                                                }}
                                                handleLocationClick={(type, name, id) => {
                                                  if (type === 'city') {
                                                    handleCitySelect({ id, name });
                                                  }
                                                }}
                                                locationType="primary"
                                              />
                                            )}
                                          </div>
                                        }
                                      >
                                        <div className="flex items-center justify-between p-2 border rounded bg-white">
                                          <span>
                                            {attr.name === 'country'
                                              ? (selectedCountry.name || 'Select Country')
                                              : ['province', 'state'].includes(attr.name)
                                                ? (selectedState.name || 'Select State/Province')
                                                : (selectedCity.name || 'Select City')}
                                          </span>
                                          <DownOutlined className="text-xs" />
                                        </div>
                                      </Popover>
                                    </div>
                                  ) : getInputType(attr.attribute_type, attr.name) === 'gender' ? (
                                    <Popover
                                      content={
                                        <div className="flex flex-col max-h-60 overflow-y-auto w-[10vw]">
                                          {gender.map((item) => (
                                            <div
                                              key={item.id}
                                              className="p-2 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
                                              onClick={() => {
                                                setTempValues(prev => ({
                                                  ...prev,
                                                  [attr.id]: item.label
                                                }));
                                              }}
                                            >
                                              <span>{item.label}</span>
                                              {tempValues[attr.id] === item.label && (
                                                <Tick width="12px" height="12px" strokeWidth="3.2" className="text-green-500" />
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      }
                                      trigger="click"
                                      placement="bottomLeft"
                                      overlayClassName="gender-popover"
                                    >
                                      <Input
                                        value={editingField === attr.id
                                          ? (tempValues[attr.id] || '')
                                          : (editedAttributes[attr.id] || '')}
                                        readOnly
                                        placeholder="Select gender"
                                        className={editingField === attr.id ? 'border-blue-300' : 'bg-gray-50'}
                                      />
                                    </Popover>
                                  ) : getInputType(attr.attribute_type, attr.name) === 'checkbox' ? (
                                    editingField === attr.id ? (
                                      <div className="flex items-center gap-2">
                                        <input
                                          type="checkbox"
                                          checked={tempValues[attr.id] === 'true'}
                                          onChange={(e) => {
                                            const newValue = e.target.checked ? 'true' : 'false';
                                            setTempValues(prev => ({
                                              ...prev,
                                              [attr.id]: newValue
                                            }));
                                          }}
                                          className="w-4 h-4"
                                        />
                                        <span className="text-sm">
                                          {tempValues[attr.id] === 'true' ? 'true' : 'false'}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="w-full">
                                        <Input
                                          value={editedAttributes[attr.id] || ''}
                                          readOnly
                                          className="bg-gray-50"
                                        />
                                      </div>
                                    )
                                  ) : (
                                    <Input
                                      type={getInputType(attr.attribute_type, attr.name)}
                                      value={editingField === attr.id
                                        ? (tempValues[attr.id] || '')
                                        : (editedAttributes[attr.id] || '')}
                                      onChange={(e) => {
                                        setTempValues(prev => ({
                                          ...prev,
                                          [attr.id]: e.target.value
                                        }));
                                      }}
                                      placeholder={`Enter ${attr.label || attr.name}`}
                                      readOnly={editingField !== attr.id}
                                      className={editingField === attr.id ? 'border-blue-300' : 'bg-gray-50'}
                                    />
                                  )}
                                  {editingField !== attr.id ? (
                                      <button 
                                        className="text-[#7B54FF] text-sm flex items-center gap-1"
                                        onClick={() => {
                                          setEditingField(attr.id);
                                          setTempValues(prev => ({
                                            ...prev,
                                            [attr.id]: editedAttributes[attr.id] || ''
                                          }));
                                        }}
                                      >
                                        <img src={ICONS?.inboxEdit} alt="edit" style={{ width: '19px', marginLeft: '10px' }} />
                                      </button>
                                    ) : (
                                      <div className="flex gap-2">
                                        <button 
                                          className="text-gray-500 hover:text-gray-700"
                                          onClick={() => {
                                            setEditingField(null);
                                            setTempValues(prev => {
                                              const newValues = {...prev};
                                              delete newValues[attr.id];
                                              return newValues;
                                            });
                                          }}
                                        >
                                          {/* <img src={ICONS?.close} alt="cancel" style={{ width: '16px' }} /> */}
                                          <Close stroke="#616874" circle={false} width="1.5vw" height="1.5vw" />
                                        </button>
                                        <button 
                                          className={`text-green-500 hover:text-green-700 ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
                                          disabled={isSaving}
                                          onClick={async () => {
                                            let newValue = tempValues[attr.id] || '';
                                          // For boolean fields, ensure we have a proper true/false string
                                          if (getInputType(attr.attribute_type, attr.name) === 'checkbox') {
                                            newValue = tempValues[attr.id] === 'true' ? 'true' : 'false';
                                          }
                                          // Call the API to save the attribute value
                                          await handleSaveAttribute(attr, scope, newValue);

                                          // Update local state
                                          setEditedAttributes(prev => ({
                                            ...prev,
                                            [attr.id]: newValue
                                          }));
                                          // Exit edit mode after save
                                          setEditingField(null);
                                          }}
                                        >
                                          {/* <img src={ICONS?.tick} alt="save" style={{ width: '16px' }} /> */}
                                          <Tick width="1vw" height="1vw" strokeWidth="3.2" />
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      }
                    >
                      <span className="inbox-edit gap-1 flex-row align-center pointer">
                        <img src={ICONS?.inboxEdit} alt="inboxEdit" style={{ width: "16px" }} />
                        <span className="text-[#7B54FF]">Edit</span>
                      </span>
                    </Popover>
                  </div>  
                  <div className="w-100">
                    {scope.profile_attributes
                      .filter(attribute => attribute.name !== 'whatsapp_opt_out')
                      .map((attribute) => (
                        <div 
                          key={attribute.id}
                          className="w-100 flex-row align-center space-between mt-20 mb-10"
                        >
                          <span className="sidebar-sub-header">
                            {attribute.label || attribute.name}
                          </span>
                          <div className="flex-row align-center" style={{ gap: '8px' }}>
                            <span className="new-body-text">
                              {attribute.value || "-"}
                            </span>

                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <span className="new-body-text" >No profile attributes available for this contact</span>
              </div>
            )}

            {/* Tags Section */}
            <div
              className="w-[92] b-radius p-[15px] m-10 gap-2 flex-column bg-white"
              style={{
                boxShadow: "0px 4px 4px 0px #0000000A",
              }}
            >
              <div className="flex-row align-center gap-5">
                <p className="font12px-500">Tags</p>
              </div>
              <div className="flex flex-wrap gap-2 mt-3">
                {attributes?.contact_person_tags_list?.length > 0 ? (
                  attributes?.contact_person_tags_list?.map((tag) => {
                    return (
                      <Label
                        id={tag?.id}
                        key={tag?.id}
                        label={tag?.tag}
                        color={tag?.display_color}
                        // color="white"
                        style={{
                          backgroundColor: hexToRgba(tag?.display_color),
                        }}
                        mainClassNames="w-40"
                        closeAction={() => closeAction(tag?.id)}
                        disableHover={true}
                      />
                    );
                  })
                ) : (
                  <span></span>
                )}
              </div>
              <div className="flex-row align-center gap-10">
                <Tags
                  toggle={isTagPopoverOpen}
                  setVisible={setIsTagPopoverOpen}
                  tags={attributes?.contact_person_tags_list || []}
                  addFunction={handleAssignTag}
                  removeFunction={handleRemoveTag}
                  Button={
                    <p className="flex text-[#616874] text-[.8vw] items-center font-[500] gap-[.4vw] cursor-pointer mt-10 w-21">
                      <AddCircle width="1vw" height="1vw" stroke="#7B54FF" strokeWidth="2.5" />
                      <span className="font12px-500">Add a Tag</span>
                    </p>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {type === "journey" && (
        <div className="w-[20vw] mb-10">
          <div className="w-100 flex-row align-center space-between bg-white">
            <Header
              title={"Customer Journey"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
            />
          </div>
          {journeyLists?.length > 0 ? (
            <div className="h-[90vh] overflow-scroll bg-white mb-20">
              {Object.entries(
                journeyLists
                  ?.sort((a, b) => new Date(b?.send_at) - new Date(a?.send_at)) // Sort by send_at in ascending order
                  .reduce((acc, item) => {
                    const date = new Date(item?.send_at);
                    const monthYear = date.toLocaleString("en-US", {
                      month: "long",
                      year: "numeric",
                    });
                    if (!acc[monthYear]) acc[monthYear] = [];
                    acc[monthYear].push(item);
                    return acc;
                  }, {})
              ).map(([monthYear, items]) => (
                <div key={monthYear} className="mb-10">
                  <div className="ml-[18px] mt-20">
                    <span className=" text-[0.75rem] font-[600] text-[var(--font-600)] bg-[var(--BG-25)] ptb-10 px-[15px] b-radius-6">
                      {monthYear}
                    </span>
                  </div>
                  {items.map((item) => {
                    const date = new Date(item?.send_at);

                    const formattedDate = date.toLocaleString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    });

                    return (
                      <div
                        key={item?.id}
                        className="relative flex-row ml-[18px] mr-5 pl-20 mb-10"
                      >
                        <div
                          className="flex flex-col items-center"
                          style={{ transform: "translate(0, 26px)" }}
                        >
                          <div className="absolute w-2 h-2 bg-[#7B54FF] rounded-full"></div>
                          <div className="w-10 h-full border border-1 mt-4"></div>
                        </div>

                        <div className="flex flex-col space-y-1 ml-[15px] mt-20 ">
                          <span className="journey14px-500  flex-row">
                            {item?.status === "READ" && (
                              <span className="mr-10 mt-5">
                                <Delivered color={"#1778F2"} />
                              </span>
                            )}
                            {item?.message}
                          </span>
                          <span className="inbox12px-500 text-[var(--font-600)]">
                            {formattedDate}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          ) : (
            <div className="m-10 w-100 text-center  h-[83vh]">
              <img src={ICONS?.emptyLoader} alt="emptyLoader" />
              <span className="pt-10 text-[1rem] font-[600] text-[var(--textBlack)]">
                No data found
              </span>
            </div>
          )}
        </div>
      )}

      {type === "attachments" && (
        <div
          className="flex flex-col w-[20vw] h-screen mb-10"
          style={{ overflowY: "auto" }}
        >
          <div className="w-100 flex flex-col align-center space-between bg-white">
            <Header
              title={"Attachments"}
              handleCancel={() => {
                setIsSideNavOpen(false);
                setIsSideNavOpenIcon4(false);
                setIsSideNavOpenIcon3(false);
                setIsSideNavOpenIcon2(false);
                setIsSideNavOpenIcon1(false);
              }}
              className="new-header"
            />
          </div>
          <div
            className="flex-1 flex-col overflow-hidden bg-white"
            style={{ boxShadow: "inset 0 6px 10px -4px rgba(0, 0, 0, 0.05)" }}
          >
            <AttachmentsManager
              items={attachments}
              activeFilter={attachmentFilter}
              onFilterChange={(filter) => {
                handleFilterChange(filter);
              }}
              onDownloadItem={handleDownloadItem}
              onDownloadItems={handleDownloadItems}
            />
          </div>
        </div>
      )}
      

      {type === "notes" && (
        <NotesSection
          setIsSideNavOpen={setIsSideNavOpen}
          notes={notes}
          setIsSideNavOpenIcon1={setIsSideNavOpenIcon1}
          setIsSideNavOpenIcon2={setIsSideNavOpenIcon2}
          setIsSideNavOpenIcon3={setIsSideNavOpenIcon3}
          setIsSideNavOpenIcon4={setIsSideNavOpenIcon4}
          noteDelete={noteDelete}
          setChatToggle={setChatToggle}
          chatToggle={chatToggle}
        />
      )}
    </div>
  );
};

export default SideNavComponent;
